"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es7.string.pad-start");
require("core-js/modules/es6.object.keys");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.ends-with");
require("core-js/modules/es6.string.starts-with");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _couponImage = require("@/api/member/couponImage");
var _memberManagement = require("@/api/member/memberManagement");
var _couponLog = require("@/api/member/couponLog");
var _couponDetail = _interopRequireDefault(require("./couponDetail.vue"));
var _coupon = require("@/api/member/coupon");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '优惠券管理',
  components: {
    couponDetail: _couponDetail.default
  },
  data: function data() {
    return {
      activeTab: 'couponList',
      detailTabs: [],
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      searchForm: {
        couponName: '',
        couponType: ''
      },
      // 发放对话框相关数据
      issueDialogVisible: false,
      selectedCoupon: null,
      memberList: [],
      memberLoading: false,
      selectedMemberIds: [],
      selectedMembers: [],
      memberSearchForm: {
        mobile: ''
      },
      // 编辑对话框相关数据
      dialogVisible: false,
      dialogTitle: '',
      couponForm: {
        typeId: null,
        typeName: '',
        typeGroup: '',
        typeMoney: 0,
        minGoodsAmount: 0,
        grossNum: '',
        imgUrl: '',
        canShare: 1
      },
      rules: {
        typeName: [{
          required: true,
          message: '请输入红包类型名称',
          trigger: 'blur'
        }],
        typeGroup: [{
          required: true,
          message: '请选择红包类型',
          trigger: 'change'
        }],
        typeMoney: [{
          required: true,
          message: '请输入券金额',
          trigger: 'blur'
        }, {
          type: 'number',
          message: '请输入数字',
          trigger: 'blur'
        }],
        minGoodsAmount: [{
          required: true,
          message: '请输入最低消费金额',
          trigger: 'blur'
        }, {
          type: 'number',
          message: '请输入数字',
          trigger: 'blur'
        }],
        grossNum: [{
          required: true,
          message: '请输入发放数量',
          trigger: 'blur'
        }, {
          type: 'number',
          message: '请输入数字',
          trigger: 'blur'
        }],
        canShare: [{
          required: true,
          message: '请选择是否分享',
          trigger: 'change'
        }]
      },
      // 券发放列表相关数据
      couponLogLoading: false,
      couponLogTableData: [],
      couponLogCurrentPage: 1,
      couponLogPageSize: 10,
      couponLogTotal: 0,
      couponLogSearchForm: {
        couponNo: '',
        userCard: '',
        status: '',
        couponId: ''
      },
      tabIndex: 0,
      imagePrefix: ''
    };
  },
  methods: {
    getImagePrefix: function () {
      var _getImagePrefix2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 1;
              return (0, _memberManagement.getImagePrefix)();
            case 1:
              response = _context.sent;
              if (response.code === 200 && response.data) {
                this.imagePrefix = response.data;
              }
              _context.next = 3;
              break;
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              console.error('获取图片前缀失败:', _t);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 2]]);
      }));
      function getImagePrefix() {
        return _getImagePrefix2.apply(this, arguments);
      }
      return getImagePrefix;
    }(),
    getImageUrl: function getImageUrl(url) {
      if (!url) return '';
      if (url.startsWith('http')) {
        return url;
      }
      var path = url.startsWith('/') ? url : '/' + url;
      if (this.imagePrefix) {
        var prefix = this.imagePrefix.endsWith('/') ? this.imagePrefix.slice(0, -1) : this.imagePrefix;
        return prefix + path;
      }
      return process.env.VUE_APP_COMMENT_IMAGE_URL + url;
    },
    handleSearch: function handleSearch() {
      this.currentPage = 1;
      this.fetchCouponList();
    },
    handleBatchSyncTcCoupon: function () {
      var _handleBatchSyncTcCoupon = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var response, _t2;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              this.loading = true;
              _context2.next = 1;
              return (0, _coupon.syncTcCoupon)();
            case 1:
              response = _context2.sent;
              if (response.code === 200) {
                this.$message.success(response.message);
                this.fetchCouponList();
              } else {
                this.$message.error(response.message || '同步失败');
              }
              _context2.next = 3;
              break;
            case 2:
              _context2.prev = 2;
              _t2 = _context2["catch"](0);
              this.$message.error('同步失败: ' + _t2.message);
            case 3:
              _context2.prev = 3;
              this.loading = false;
              return _context2.finish(3);
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 2, 3, 4]]);
      }));
      function handleBatchSyncTcCoupon() {
        return _handleBatchSyncTcCoupon.apply(this, arguments);
      }
      return handleBatchSyncTcCoupon;
    }(),
    resetSearch: function resetSearch() {
      this.searchForm = {
        couponName: '',
        couponType: ''
      };
      this.handleSearch();
    },
    fetchCouponList: function () {
      var _fetchCouponList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var params, response, _t3;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.loading = true;
              _context3.prev = 1;
              params = {
                page: this.currentPage,
                limit: this.pageSize
              };
              if (this.searchForm.couponName) {
                params.typeName = this.searchForm.couponName;
              }
              if (this.searchForm.couponType) {
                params.typeGroup = this.searchForm.couponType;
              }
              Object.keys(params).forEach(function (key) {
                if (params[key] === '' || params[key] === null || params[key] === undefined) {
                  delete params[key];
                }
              });
              _context3.next = 2;
              return (0, _coupon.getCouponPage)(params);
            case 2:
              response = _context3.sent;
              if (response.code === 200) {
                this.tableData = response.records || [];
                this.total = response.total;
              } else {
                this.$message.error(response.message || '获取券列表失败');
              }
              _context3.next = 4;
              break;
            case 3:
              _context3.prev = 3;
              _t3 = _context3["catch"](1);
              this.$message.error('获取券列表失败: ' + _t3.message);
            case 4:
              _context3.prev = 4;
              this.loading = false;
              return _context3.finish(4);
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[1, 3, 4, 5]]);
      }));
      function fetchCouponList() {
        return _fetchCouponList.apply(this, arguments);
      }
      return fetchCouponList;
    }(),
    getCouponTypeText: function getCouponTypeText(type) {
      var typeMap = {
        1: '满减券',
        2: '折扣券',
        3: '品项券',
        4: '赠品券',
        5: '免邮券'
      };
      return typeMap[type] || '未知类型';
    },
    formatAmount: function formatAmount(amount) {
      return typeof amount === 'number' ? amount.toFixed(2) : amount;
    },
    formatDate: function formatDate(timestamp) {
      if (!timestamp) return '';
      var date = new Date(timestamp);
      var y = date.getFullYear();
      var m = String(date.getMonth() + 1).padStart(2, '0');
      var d = String(date.getDate()).padStart(2, '0');
      var h = String(date.getHours()).padStart(2, '0');
      var i = String(date.getMinutes()).padStart(2, '0');
      var s = String(date.getSeconds()).padStart(2, '0');
      return "".concat(y, "-").concat(m, "-").concat(d, " ").concat(h, ":").concat(i, ":").concat(s);
    },
    openIssueDialog: function openIssueDialog(coupon) {
      this.selectedCoupon = coupon;
      this.issueDialogVisible = true;
      this.selectedMembers = [];
      this.memberSearchForm = {
        mobile: ''
      };
      this.fetchMemberList();
    },
    fetchMemberList: function () {
      var _fetchMemberList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var params, response, _t4;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.memberLoading = true;
              _context4.prev = 1;
              params = {
                page: 1,
                limit: 100
              };
              if (this.memberSearchForm.mobile) {
                params.mobilePhone = this.memberSearchForm.mobile;
              }
              _context4.next = 2;
              return (0, _memberManagement.xyUsersPage)(params);
            case 2:
              response = _context4.sent;
              if (response.code === 200) {
                this.memberList = response.records.map(function (member) {
                  return {
                    key: member.id,
                    label: "".concat(member.nickName || member.mobilePhone || '未知用户', " ").concat(member.mobilePhone || ''),
                    mobile: member.mobilePhone
                  };
                }) || [];
                this.memberTotal = response.total || 0;
              } else {
                this.$message.error(response.message || '获取会员列表失败');
                this.memberList = [];
                this.memberTotal = 0;
              }
              _context4.next = 4;
              break;
            case 3:
              _context4.prev = 3;
              _t4 = _context4["catch"](1);
              this.$message.error('获取会员列表失败: ' + _t4.message);
              this.memberList = [];
              this.memberTotal = 0;
            case 4:
              _context4.prev = 4;
              this.memberLoading = false;
              return _context4.finish(4);
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[1, 3, 4, 5]]);
      }));
      function fetchMemberList() {
        return _fetchMemberList.apply(this, arguments);
      }
      return fetchMemberList;
    }(),
    handleMemberSearch: function handleMemberSearch() {
      this.fetchMemberList();
    },
    resetMemberSearch: function resetMemberSearch() {
      this.memberSearchForm = {
        mobile: ''
      };
      this.fetchMemberList();
    },
    handleTransferChange: function handleTransferChange(value, direction, movedKeys) {
      var _this = this;
      console.log('Transfer changed:', value, direction, movedKeys);
      this.selectedMembers = this.memberList.filter(function (member) {
        return _this.selectedMemberIds.includes(member.key);
      });
      console.log('Selected members:', this.selectedMembers);
    },
    handleIssueCoupon: function () {
      var _handleIssueCoupon = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var issueData, response, _t5;
        return regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (!(this.selectedMembers.length === 0)) {
                _context5.next = 1;
                break;
              }
              this.$message.warning('请至少选择一个会员');
              return _context5.abrupt("return");
            case 1:
              _context5.prev = 1;
              issueData = {
                userIds: this.selectedMembers.map(function (member) {
                  return member.key;
                }),
                couponId: this.selectedCoupon.typeId
              };
              _context5.next = 2;
              return (0, _coupon.issueCoupon)(issueData);
            case 2:
              response = _context5.sent;
              if (response.code === 200) {
                this.$message.success("\u7EA2\u5305\u5DF2\u6210\u529F\u53D1\u653E\u7ED9 ".concat(this.selectedMembers.length, " \u4E2A\u4F1A\u5458"));
                this.issueDialogVisible = false;
              } else {
                this.$message.error(response.message || '红包发放失败');
              }
              _context5.next = 4;
              break;
            case 3:
              _context5.prev = 3;
              _t5 = _context5["catch"](1);
              this.$message.error('红包发放失败: ' + (_t5.message || '未知错误'));
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[1, 3]]);
      }));
      function handleIssueCoupon() {
        return _handleIssueCoupon.apply(this, arguments);
      }
      return handleIssueCoupon;
    }(),
    handleAddCoupon: function handleAddCoupon() {
      this.dialogTitle = '新增红包类型';
      this.couponForm = {
        typeId: null,
        typeName: '',
        typeGroup: '',
        typeMoney: 0,
        minGoodsAmount: 0,
        grossNum: '',
        imgUrl: '',
        canShare: 1
      };
      this.dialogVisible = true;
    },
    handleView: function () {
      var _handleView = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee6(row) {
        var response, newTabName, _t6;
        return regeneratorRuntime.wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              _context6.next = 1;
              return (0, _coupon.getCouponById)(row.typeId);
            case 1:
              response = _context6.sent;
              if (response.code === 200) {
                newTabName = "detail-".concat(++this.tabIndex);
                this.detailTabs.push({
                  title: "\u7EA2\u5305\u7C7B\u578B\u8BE6\u60C5 - ".concat(response.data.typeName || row.typeName),
                  name: newTabName,
                  couponData: response.data || row
                });
                this.activeTab = newTabName;
              } else {
                this.$message.error(response.message || '获取红包类型详情失败');
              }
              _context6.next = 3;
              break;
            case 2:
              _context6.prev = 2;
              _t6 = _context6["catch"](0);
              this.$message.error('获取红包类型详情失败: ' + _t6.message);
            case 3:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[0, 2]]);
      }));
      function handleView(_x) {
        return _handleView.apply(this, arguments);
      }
      return handleView;
    }(),
    removeTab: function removeTab(targetName) {
      var tabs = this.detailTabs;
      var activeName = this.activeTab;
      if (activeName === targetName) {
        tabs.forEach(function (tab, index) {
          if (tab.name === targetName) {
            var nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.name;
            }
          }
        });
      }
      this.activeTab = activeName === targetName ? 'couponList' : activeName;
      this.detailTabs = tabs.filter(function (tab) {
        return tab.name !== targetName;
      });
    },
    handleSyncTcCoupon: function () {
      var _handleSyncTcCoupon = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee7(row) {
        var response, _t7;
        return regeneratorRuntime.wrap(function (_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              this.loading = true;
              _context7.next = 1;
              return (0, _coupon.syncTcCoupon)(row.thirdCouponId);
            case 1:
              response = _context7.sent;
              if (response.code === 200) {
                this.$message.success(response.message || '同步中请稍后查看');
                this.fetchCouponList();
              } else {
                this.$message.error(response.message || '同步天财红包失败');
              }
              _context7.next = 3;
              break;
            case 2:
              _context7.prev = 2;
              _t7 = _context7["catch"](0);
              this.$message.error('同步天财红包失败: ' + _t7.message);
            case 3:
              _context7.prev = 3;
              this.loading = false;
              return _context7.finish(3);
            case 4:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this, [[0, 2, 3, 4]]);
      }));
      function handleSyncTcCoupon(_x2) {
        return _handleSyncTcCoupon.apply(this, arguments);
      }
      return handleSyncTcCoupon;
    }(),
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.fetchCouponList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchCouponList();
    },
    beforeImageUpload: function beforeImageUpload(file) {
      var isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG 或 PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },
    handleCouponLogSearch: function handleCouponLogSearch() {
      this.couponLogCurrentPage = 1;
      this.fetchCouponLogList();
    },
    resetCouponLogSearch: function resetCouponLogSearch() {
      this.couponLogSearchForm = {
        couponNo: '',
        userCard: '',
        status: '',
        couponId: ''
      };
      this.handleCouponLogSearch();
    },
    fetchCouponLogList: function () {
      var _fetchCouponLogList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var params, response, _t8;
        return regeneratorRuntime.wrap(function (_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              this.couponLogLoading = true;
              _context8.prev = 1;
              params = {
                page: this.couponLogCurrentPage,
                limit: this.couponLogPageSize
              };
              if (this.couponLogSearchForm.couponNo) {
                params.couponNo = this.couponLogSearchForm.couponNo;
              }
              if (this.couponLogSearchForm.userCard) {
                params.userCard = this.couponLogSearchForm.userCard;
              }
              if (this.couponLogSearchForm.status) {
                params.status = this.couponLogSearchForm.status;
              }
              if (this.couponLogSearchForm.couponId) {
                params.couponId = this.couponLogSearchForm.couponId;
              }
              Object.keys(params).forEach(function (key) {
                if (params[key] === '' || params[key] === null || params[key] === undefined) {
                  delete params[key];
                }
              });
              _context8.next = 2;
              return (0, _couponLog.getCouponLogPageList)(params);
            case 2:
              response = _context8.sent;
              if (response.code === 200) {
                this.couponLogTableData = response.records || [];
                this.couponLogTotal = response.total;
              } else {
                this.$message.error(response.message || '获取券发放列表失败');
              }
              _context8.next = 4;
              break;
            case 3:
              _context8.prev = 3;
              _t8 = _context8["catch"](1);
              this.$message.error('获取券发放列表失败: ' + _t8.message);
            case 4:
              _context8.prev = 4;
              this.couponLogLoading = false;
              return _context8.finish(4);
            case 5:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this, [[1, 3, 4, 5]]);
      }));
      function fetchCouponLogList() {
        return _fetchCouponLogList.apply(this, arguments);
      }
      return fetchCouponLogList;
    }(),
    getCouponLogStatusText: function getCouponLogStatusText(status) {
      var statusMap = {
        1: '发送中',
        2: '异常',
        3: '成功'
      };
      return statusMap[status] || '未知状态';
    },
    getCouponLogStatusType: function getCouponLogStatusType(status) {
      var typeMap = {
        1: 'info',
        3: 'success',
        2: 'danger'
      };
      return typeMap[status] || 'info';
    },
    handleCouponLogSizeChange: function handleCouponLogSizeChange(val) {
      this.couponLogPageSize = val;
      this.couponLogCurrentPage = 1;
      this.fetchCouponLogList();
    },
    handleCouponLogCurrentChange: function handleCouponLogCurrentChange(val) {
      this.couponLogCurrentPage = val;
      this.fetchCouponLogList();
    },
    submitCouponForm: function submitCouponForm() {
      var _this2 = this;
      this.$refs.couponForm.validate(function (valid) {
        if (valid) {
          _this2.$message.success('提交成功');
          _this2.dialogVisible = false;
          _this2.fetchCouponList();
        } else {
          _this2.$message.error('请填写完整信息');
          return false;
        }
      });
    },
    handleDialogClose: function handleDialogClose() {
      this.$refs.couponForm.resetFields();
    },
    handleImageUpload: function () {
      var _handleImageUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee9(_ref, row) {
        var file, formData, res, _t9;
        return regeneratorRuntime.wrap(function (_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              file = _ref.file;
              _context9.prev = 1;
              formData = new FormData();
              formData.append('file', file);
              formData.append('path', '/coupon/');
              _context9.next = 2;
              return (0, _couponImage.uploadCouponImage)(formData);
            case 2:
              res = _context9.sent;
              if (!(res.code === 200 && res.data)) {
                _context9.next = 4;
                break;
              }
              row.imgUrl = res.data;
              this.$message.success('图片上传成功');
              _context9.next = 3;
              return (0, _coupon.updateCoupon)(row);
            case 3:
              this.$message.success('红包类型更新成功');
              _context9.next = 5;
              break;
            case 4:
              this.$message.error(res.message || '图片上传失败');
            case 5:
              _context9.next = 7;
              break;
            case 6:
              _context9.prev = 6;
              _t9 = _context9["catch"](1);
              this.$message.error('图片上传失败: ' + (_t9.message || '未知错误'));
            case 7:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this, [[1, 6]]);
      }));
      function handleImageUpload(_x3, _x4) {
        return _handleImageUpload.apply(this, arguments);
      }
      return handleImageUpload;
    }(),
    handleClearImage: function () {
      var _handleClearImage = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee0(row) {
        var _t0;
        return regeneratorRuntime.wrap(function (_context0) {
          while (1) switch (_context0.prev = _context0.next) {
            case 0:
              _context0.prev = 0;
              _context0.next = 1;
              return this.$confirm('确定清理该图片吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              });
            case 1:
              row.imgUrl = '';
              _context0.next = 2;
              return (0, _coupon.updateCoupon)(row);
            case 2:
              this.$message.success('图片已清理');
              _context0.next = 4;
              break;
            case 3:
              _context0.prev = 3;
              _t0 = _context0["catch"](0);
              if (_t0 !== 'cancel') {
                this.$message.error('清理图片失败: ' + (_t0.message || '未知错误'));
              }
            case 4:
            case "end":
              return _context0.stop();
          }
        }, _callee0, this, [[0, 3]]);
      }));
      function handleClearImage(_x5) {
        return _handleClearImage.apply(this, arguments);
      }
      return handleClearImage;
    }()
  },
  mounted: function mounted() {
    this.getImagePrefix();
    this.fetchCouponList();
    this.fetchCouponLogList();
  }
};